import api from 'ApiConfig';

const studentService = {
  getStudent: async (teacherId, std, div) => {
    return api.post('/teacher/get-students-data', { teacherId, std, div });
  },

  getStudentsDetails: async (courseId, batchId) => {
    return api.post('/teacher/get-all-student', {
      courseId,
      batchId,
    });
  },
  getAllStudentForAttendance: async (courseId, batchId, date) => {
    return api.post('/teacher/get-all-student-for-attendance', {
      courseId,
      batchId,
      date,
    });
  },
  getStudent: async (courseId, batchId) => {
    return api.post('/teacher/get-students', {
      courseId,
      batchId,
    });
  },

  markStudentAttendance: async (data) => {
    return api.post('/teacher/submit-attendance', data);
  },

  getAllJobs: async (courseId) => {
    return api.post('/teacher/get-job-post', { courseId });
  },
  getFeedbackForJob: async (jobAssignmentId) => {
    console.log(jobAssignmentId, 'jobAssignmentId');
    return api.post(
      '/teacher/get-assigned-job-feedback-all-students',
      jobAssignmentId
    );
  },
  submitMarks: async (payload) => {
    return api.post('/teacher/add-mock-marks', payload);
  },

  getUniqueSubjects: async (courseId, batchId) => {
    return api.get(`/teacher/get-subject`, {
      params: { courseId, batchId },
    });
  },
  getMockMarksByDate: async (courseId, batchId, testDate, subjectName) => {
    return api.post('/teacher/get-existing-marks', {
      courseId,
      batchId,
      testDate,
      subjectName,
    });
  },
  getUniqueDates: async (subjectName) => {
    return api.get(`/teacher/get-mock-dates`, {
      params: { subjectName },
    });
  },

  markCourseComplete: async (batchId, courseId, action) => {
    return api.post('/teacher/mark-course-complete', {
      batchId,
      courseId,
      action,
    });
  },

  getBatchCourses: async (batchId) => {
    return api.post('/teacher/get-batch-courses', { batchId });
  },
};

export default studentService;
